import { SimpleCheckList, SimpleCheckListItem } from "@components"
import { CheckCircleIcon, InformationCircleIcon, XCircleIcon } from "@heroicons/react/24/solid"
import { Button } from "@heroui/react"
import PropTypes from "prop-types"

const CheckList = ({ 
  handleStartBookingConfirmationWizard, 
  isReadOnly, 
  noOfBookings, 
  noOfBookingConfirmationsSent 
}) => (
  <SimpleCheckList>
    {noOfBookings === 0 && (
      <SimpleCheckListItem 
        title={`You currently have no booking confirmation emails to send.`}
        description="Sending booking confirmation emails is optional."
        icon={<InformationCircleIcon className="w-8 h-8 text-blue-500" />}
        showDivider={false}
      />
    )}

    {noOfBookings > 0 && noOfBookingConfirmationsSent < noOfBookings && (
      <SimpleCheckListItem 
        title={`${noOfBookingConfirmationsSent} of ${noOfBookings} confirmation emails have not been sent.`}
        description="Sending booking confirmation emails is optional."
        icon={<XCircleIcon className="w-8 h-8 text-red-500" />}
        button={<Button color="primary" isDisabled={isReadOnly} onPress={() => handleStartBookingConfirmationWizard()} className="min-w-52">Send Outstanding Emails</Button>}
        showDivider={false}
      />
    )}

    {noOfBookings > 0 && noOfBookingConfirmationsSent === noOfBookings && (
      <SimpleCheckListItem 
        title={`${noOfBookingConfirmationsSent} of ${noOfBookings} confirmation emails have been sent.`}
        description="Sending booking confirmation emails is optional."
        icon={<CheckCircleIcon className="w-8 h-8 text-green-500" />}
        showDivider={false}
      />
    )}
  </SimpleCheckList>
)

CheckList.propTypes = {
  handleStartBookingConfirmationWizard: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  noOfBookings: PropTypes.number.isRequired,
  noOfBookingConfirmationsSent: PropTypes.number.isRequired,
}

export default CheckList